// Сводный дэшборд проекта — первая секция; заголовок фильтруется по своему праву (dashboard).
// «Конкуренты» — отдельное право competitors; заголовок умеет проверять только один ресурс,
// поэтому при одном праве competitors пункт виден без заголовка (admin видит всё).
export default [
  {
    header: 'Дэшборд',
    resource: 'dashboard',
    action: 'view',
  },
  {
    title: 'Своя Игра',
    route: 'dashboard-sifnf',
    icon: 'ActivityIcon',
    resource: 'dashboard',
    action: 'view',
  },
  {
    title: 'Конкуренты',
    route: 'competitors-list',
    icon: 'TrendingUpIcon',
    resource: 'competitors',
    action: 'view',
  },
]
